import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ProjectModel } from 'src/app/models/project.model';
import { CutoffService } from 'src/app/services/cutoff.service';
import { InventorysService } from 'src/app/services/inventory.service';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-projects-diagramation-inventory-detail',
  templateUrl: './projects-diagramation-inventory-detail.component.html',
  styleUrls: ['./projects-diagramation-inventory-detail.component.scss']
})
export class ProjectsDiagramationInventoryDetailComponent implements OnInit { 

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  media : any;
  
  displayedColumns: string[] = [];
  allColumns: string[] = [];
  dataSource: any = [];
  data_inv: any = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private projectService : ProjectsService,
    private main : MainService,
    private _cutoffS : CutoffService,
    private invService : InventorysService
  ) {
    this.media = data.media;
    this.buildDetalle();
   }

  ngOnInit(): void {
    console.log("this data", this.data);
  }



  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

   if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
   }
  }

  buildDetalle(){
  
      this.data_inv = this.getPops(this.media.data);
      if (this.data_inv.length > 0) {
        this.displayedColumns = Object.keys(this.data_inv[0]).filter(key => key && key.trim() !== '' && key !== 'data');
        this.allColumns = this.displayedColumns;
        this.dataSource = new MatTableDataSource(this.data_inv);        
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
  }

  private getPops(e: any): any[] {
    const selectedMap = this.createSelectedMap(e.pops_t);
    const detalle: any[] = [];

    (e.pops || []).forEach((pop: any) => {
      const { total, seleccionado } = this.calculateTotals(pop, selectedMap, e.tipo);
      detalle.push(this.buildDetailRow(pop, total, seleccionado, e.tipo));
    });

    return detalle;
  }

  private createSelectedMap(pops_t: any[]): Map<number, number> {
    const selectedMap = new Map<number, number>();
    (pops_t || []).forEach((pop: any) => {
      (pop.configs || []).forEach((c: any) => {
        selectedMap.set(Number(c.id_pop_config), c.cantidad);
      });
    });
    return selectedMap;
  }

  private calculateTotals(pop: any, selectedMap: Map<number, number>, tipo: number): { total: number, seleccionado: number } {
    let total = 0;
    let seleccionado = 0;

    (pop.configs || []).forEach((config: any) => {
      const s = selectedMap.get(config.id_pop_config) || 0;
      const mediaItem = this.media.all_media.find((x: any) => x.id_pop_config == config.id_pop_config);
      
      if (mediaItem) {
        if (tipo === 4) {
          total = mediaItem.inventario_original;
        } else {
          total += mediaItem.inventario_original;
        }
      }
      seleccionado += s;
    });

    return { total, seleccionado };
  }

  private buildDetailRow(pop: any, total: number, seleccionado: number, tipo: number): any {
    const unidadesTotales = total * pop.posiciones;
    const unidadesDiagramadas = seleccionado * pop.pos_diagramadas;
    const unidadesDisponibles = unidadesTotales - ((seleccionado) * (tipo === 4 && pop.pos_diagramadas === 0 ? 1 : pop.pos_diagramadas));

    // ["Unidades Disponibles"]: (total * pop.posiciones) - 
    // ((e.tipo == 4 ? seleccionado_sum : seleccionado) * ( e.tipo == 4  && pop.pos_diagramadas == 0 ? 1 :  pop.pos_diagramadas)),
    // ((seleccionado) * ( e.tipo == 4  && pop.pos_diagramadas == 0 ? 1 :  pop.pos_diagramadas)),
    //  ["data_config"]: pop.configs 
    return {
      ["Nombre"]: pop.nombre,
      ["Pos. Totales"] : pop.posiciones,
      ["Pos. Diagramadas"]: pop.pos_diagramadas,
      ["Pos. Disponibles"]: pop.posiciones - pop.pos_diagramadas,
      ["Inventario Total"]: total,
      ["Inventario Seleccionado"]: seleccionado,
      ["Inventario Disponible"]: total - seleccionado,
      ["Unidades Totales"]: unidadesTotales,
      ["Unidades Diagramadas"]: unidadesDiagramadas,
      ["Unidades Disponibles"]: unidadesDisponibles,
    };
  }

  generateExcelResumen(){
    if(this.data_inv.length == 0){
      Swal.fire({
        icon: 'warning',
        title: 'Aviso',
        text: 'No hay datos de resumen actualmente'          
      });
    }else{
      this.main.generateExcel(this.data_inv, "Inventario " + this.media.nombre, "inv");
    }
  }

}
